<smw-collapse [collapsed]="false">
  <div collapse-title class="title-xs title" [innerHTML]="title()"></div>
  <div collapse-body class="body-md content" [innerHTML]="content()"></div>
</smw-collapse>
